let axiosLoggingOut = false;

export const setAxiosLoggingOut = (value) => {
  axiosLoggingOut = value;
};

export const isAxiosLoggingOut = () => axiosLoggingOut;